import { CookieBanner } from "./CookieBanner";
import html from './cookie-banner.raw.html';

let cookieName = '#{CookieConfiguration_PreferencesCookieName}';
if (cookieName.includes('CookieConfiguration_PreferencesCookieName')) {
	cookieName = 'cookie-preferences';
}
let cookieDomain = '#{CookieConfiguration_Domain}';
if (cookieDomain.includes('CookieConfiguration_Domain')) {
	cookieDomain = '';
}

new CookieBanner(cookieName, cookieDomain, html).Init();
